/**
 * Common Components
 */
Vue.component('v-header', require('./Header').default);
Vue.component('v-footer', require('./Footer').default);
Vue.component('product', require('./Product').default);
Vue.component('custom-text', require('./CustomText').default);
Vue.component('passe_product', require('./PasseProduct').default);
Vue.component('banner', require('./Banner').default);
Vue.component('sticky-footer', require('./StickyFooter').default);
Vue.component('dynamic-tariffs', require('./DynamicTariffs').default);
/**
 * Pages Components
 */
Vue.component('home-page', require('./Pages/HomePage').default);
Vue.component('home-page-cyber', require('./Pages/HomePageCyber').default);
Vue.component('flex-page', require('./Pages/FlexPage').default);
Vue.component('fix-page', require('./Pages/FixPage').default);
Vue.component('health-page', require('./Pages/HealthPage').default);
Vue.component('card-products-page', require('./Pages/CardProductsPage').default);
Vue.component('fix-date-change-page', require('./Pages/FixDateChangePage').default);

/**
 * Tickets Components
 */
Vue.component('today-product', require('./TodayTicket').default);
Vue.component('fix-ticket', require('./FixTicket').default);
Vue.component('fix-ticket-header', require('./FixTicketHeader').default);

/**
 * Calendar Components
 */
Vue.component('calendar', require('./Calendar').default);
Vue.component('calendar-day-event', require('./CalendarDayEvent').default);

/**
 * Dashboard Components
 */
Vue.component('dashboard-wtp-card-details', require('./WtpCardDetails').default);

/**
 * Checkout components
 */
Vue.component('order-by-email-button', require('./OrderByEmailButton').default);

/**
 * Passes Components
 */

Vue.component('v-header-passes', require('./HeaderPasses.vue').default);
Vue.component('sticky-footer-passes', require('./StickyFooterPasses.vue').default);
Vue.component('list-passes', require('./ListPasses.vue').default);
Vue.component('cart-ticket-passes', require('./CartTicketPasses.vue').default);

/**
 * Icon Components
 */
Vue.component('icon-base', require('./icons/IconBase').default);
Vue.component('menu-bars-icon', require('./icons/MenuBarsIcon').default);
Vue.component('circle-times-icon', require('./icons/CircleTimesIcon').default);
Vue.component('check-icon', require('./icons/CheckIcon').default);
Vue.component('times-icon', require('./icons/TimesIcon').default);
Vue.component('minus-icon', require('./icons/MinusIcon').default);
Vue.component('plus-icon', require('./icons/PlusIcon').default);
Vue.component('chevron-up-icon', require('./icons/ChevronUpIcon').default);
Vue.component('chevron-down-icon', require('./icons/ChevronDownIcon').default);
Vue.component('user-circle-icon', require('./icons/UserCircleIcon').default);
Vue.component('info-circle-icon', require('./icons/InfoCircleIcon').default);
Vue.component('sort-down-icon', require('./icons/SortDownIcon').default);
Vue.component('arrow-alt-circle-left-icon', require('./icons/ArrowAltCircleLeft').default);
Vue.component('arrow-alt-circle-right-icon', require('./icons/ArrowAltCircleRight').default);
Vue.component('shopping-cart-icon', require('./icons/ShoppingCartIcon').default);
Vue.component('card-icon', require('./icons/CardIcon').default);
Vue.component('purchase-icon', require('./icons/PurchaseIcon').default);
Vue.component('news-icon', require('./icons/NewsIcon').default);
Vue.component('logout-icon', require('./icons/LogoutIcon').default);
Vue.component('loading-icon', require('./icons/LoaderIcon').default);



// WEBPACK FOOTER //
// ./src/components/bootstrap.js